import { ieee, mla, mla7, mla8 } from './styleConstants'

export const easilyTextList = [
  [ieee, 'book'],
  [ieee, 'cartoon'],
  [ieee, 'conference'],
  [ieee, 'database'],
  [ieee, 'dictionary'],
  [ieee, 'film/online video'],
  [ieee, 'government publication'],
  [ieee, 'manuscript'],
  [ieee, 'multivolume'],
  [ieee, 'musical recording'],
  [ieee, 'patent'],
  [ieee, 'thesis'],
  [ieee, 'tv/radio'],
  [mla8, 'bible'],
  [mla8, 'brochure'],
  [mla8, 'chapter'],
  [mla8, 'manuscript'],
  [mla8, 'multivolume'],
  [mla8, 'newsletter'],
  [mla8, 'pamphlet'],
  [mla8, 'patent'],
  [mla8, 'performance'],
  [mla8, 'photo'],
  [mla8, 'press release'],
  [mla8, 'software'],
  [mla8, 'thesis'],
  [mla8, 'tv/radio'],
  [mla, 'dictionary'],
  [mla, 'government publication'],
  [mla, 'digital image'],
  [mla, 'interview'],
  [mla, 'lecture'],
  [mla, 'magazine'],
  [mla, 'encyclopedia'],
  [mla, 'musical recording'],
  [mla, 'thesis'],
  [mla7, 'advertisement'],
  [mla7, 'blog'],
  [mla7, 'book'],
  [mla7, 'cartoon'],
  [mla7, 'conference'],
  [mla7, 'database'],
  [mla7, 'film/online video'],
  [mla7, 'digital image'],
  [mla7, 'introduction'],
  [mla7, 'journal'],
  [mla7, 'letter'],
  [mla7, 'painting'],
  [mla7, 'patent'],
  [mla7, 'report'],
  [mla7, 'thesis'],
]

export const easyTextDesc = (style: string, source: string): string => {
  return `Easily cite ${source} in ${style} format with Citation Machine. Properly credit your sources and create accurate citations for academic or professional use. Get started now!`
}
